import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";
import ErrorState from "../../../../common/error";

export default function view() {
  const $this = this;
  const { DATA, dispatch, $charge, $inputs } = this;
  const oneYear = 31536000;

  return (view = ViewFactory({
    NAME: 'BANK_TRANSFER_INIT_VIEW',
    inputs: ['accountnumber', 'accountname'],
    next() {
      const currency = getValueAtPath(DATA, 'currency') || 'NGN';

      switch (currency) {
        case 'EUR':
        case 'GBP': {
          let data = {
            is_bank_transfer: undefined,
            is_uk_bank_charge2: true,
            accountname: 'Account Name',
            payment_type: 'account',
          }
          $charge.init({ data });

          break;
        }

        case 'EGP':
        case 'KES': {
          const accountnumber = getValueAtPath($inputs, '[accountnumber].value');
          const accountname = getValueAtPath($inputs, '[accountname].value');
          let firstname = '';
          let lastname = '';

          const splitName = accountname.trim().split(/\s+/);
          if (splitName.length === 1) {
            firstname = splitName[0];
            lastname = '';
          }
          firstname = splitName[0];
          lastname = splitName.slice(1).join(' ');
          
          let data = {
            firstname,
            lastname,
            customer_account_number: accountnumber
          }
          $charge.init({ data });

          break;
        }

        case 'NGN':
        case 'GHS':
        case 'USD': {
          const accountNumberExpiryTime = getValueAtPath(DATA, 'expires');

          if (accountNumberExpiryTime && (accountNumberExpiryTime < 60 || accountNumberExpiryTime > oneYear)) {
            setTimeout(() => dispatch(
              ErrorState.actions.updateErrorMessage("bank.transfer.expiry.error")
            ), 100);
          } else {
            $charge.init();
          }

          break;
        }

        default: {
          $charge.init();

          break;
        }
      }
    }
  }).call(this));
}
